// LanguageSwitch.jsx — Sprachumschalter (Dropdown, 7 Sprachen)
import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitch.css';

const LANGS = [
  { code: 'de', flag: '🇩🇪', short: 'DE', label: 'Deutsch' },
  { code: 'en', flag: '🇬🇧', short: 'EN', label: 'English' },
  { code: 'it', flag: '🇮🇹', short: 'IT', label: 'Italiano' },
  { code: 'fr', flag: '🇫🇷', short: 'FR', label: 'Français' },
  { code: 'es', flag: '🇪🇸', short: 'ES', label: 'Español' },
  { code: 'cs', flag: '🇨🇿', short: 'CS', label: 'Čeština' },
  { code: 'sk', flag: '🇸🇰', short: 'SK', label: 'Slovenčina' },
];

export default function LanguageSwitch({ variant = 'default' }) {
  const { i18n } = useTranslation();
  const current  = i18n.language?.slice(0, 2) || 'de';
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const activeLang = LANGS.find(l => l.code === current) ?? LANGS[0];

  useEffect(() => {
    const handler = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const select = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className={`lang-switch lang-switch--${variant}`} ref={ref}>
      <button
        className="lang-trigger"
        onClick={() => setOpen(o => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="lang-flag">{activeLang.flag}</span>
        <span className="lang-short">{activeLang.short}</span>
        <span className={`lang-arrow ${open ? 'open' : ''}`}>▾</span>
      </button>

      {open && (
        <ul className="lang-dropdown" role="listbox">
          {LANGS.map(l => (
            <li
              key={l.code}
              role="option"
              aria-selected={l.code === current}
              className={`lang-option ${l.code === current ? 'active' : ''}`}
              onClick={() => select(l.code)}
            >
              <span className="lang-flag">{l.flag}</span>
              <span className="lang-label">{l.label}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
